import TablePagination from '@mui/material/TablePagination';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

import { Loadable } from 'stores';

import { loadService } from '../../services/load';

type Props = {
  store: Loadable<any, any>;
  swichedOnTop: boolean;
};

const PaginationComponent = ({ store, swichedOnTop }: Props) => {
  const { paginationMeta } = store;
  const page = store.page;
  const { per_page, total } = paginationMeta;
  return (
    <TablePagination
      component='div'
      count={total || 0}
      rowsPerPage={per_page || 30}
      className={classnames({ pagination: !swichedOnTop })}
      classes={{
        selectLabel: 'caption',
        displayedRows: 'caption',
        select: 'choose-num',
        selectIcon: 'choose-num-svg',
      }}
      rowsPerPageOptions={[30, 50, 100, 200]}
      page={page - 1}
      backIconButtonProps={{
        'aria-label': 'Previous Page',
      }}
      nextIconButtonProps={{
        'aria-label': 'Next Page',
      }}
      onPageChange={(event, page) => {
        loadService.loadResources({}, page + 1);
      }}
      onRowsPerPageChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        loadService.loadResources({ limit: Number(event.target.value) });
      }}
    />
  );
};

export const Pagination = observer(PaginationComponent);
